document.addEventListener('DOMContentLoaded', () => {

  const switcher = document.getElementById('size-switcher');

  function getCurrentSystem() {
    return switcher?.value || localStorage.getItem('sizeSystem') || 'EU';
  }

  // =========================
  // ✅ UPDATE PRODUCT SIZES
  // =========================
  function updateProductSizes() {

    const system = getCurrentSystem();

    document.querySelectorAll('.ctm-variant-options').forEach(wrapper => {

      const input = wrapper.querySelector('input');
      const labelSpan = wrapper.querySelector('label span');

      if (!input || !labelSpan) return;

      const base = input.value;
      const converted = sizeMap[base]?.[system] || base;

      // update UI
      if (labelSpan.innerText !== converted) {
        labelSpan.innerText = converted;
      }

      // store per base size (🔥 important for future)
      localStorage.setItem('size_' + base, converted);

    });

    updateSelectedLabel(system);
  }

  // =========================
  // ✅ STORE SELECTED SIZE
  // =========================
  function updateSelectedLabel(system) {

    const selectedInput = document.querySelector('.ctm-variant-options input:checked');
    const label = document.querySelector('[data-option-value]');

    if (!selectedInput || !label) return;

    const base = selectedInput.value;
    const converted = sizeMap[base]?.[system] || base;

    if (label.innerText !== converted) {
      label.innerText = converted;
    }

    // 🔥 store selected
    localStorage.setItem('selectedSizeLabel', converted);
    localStorage.setItem('selectedSizeBase', base);

  }

  // =========================
  // ✅ INITIAL LOAD
  // =========================
  const savedSystem = localStorage.getItem('sizeSystem') || 'EU';

  if (switcher) switcher.value = savedSystem;

  setTimeout(updateProductSizes, 100);

  // =========================
  // ✅ SWITCH CHANGE
  // =========================
  if (switcher) {
    switcher.addEventListener('change', function () {

      localStorage.setItem('sizeSystem', this.value);
      updateProductSizes();

    });
  }

  // =========================
  // ✅ VARIANT CHANGE
  // =========================
  document.addEventListener('change', function(e) {

    if (e.target.matches('.ctm-variant-options input')) {
      setTimeout(updateProductSizes, 50);
    }

  });

});

